<template>
  <el-dialog
    title="考试科目管理"
    :visible.sync="visible"
    width="560px"
    append-to-body
    @closed="handleClosed">
    <div style="margin-bottom: 10px;">
      <el-input
        v-model="config.subjectName"
        placeholder="请输入考试科目"
        style="width: 240px;">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
      <el-button
        style="margin-left: 10px;"
        type="primary"
        @click="updateitem({})">新增</el-button>
    </div>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="考试科目"
        prop="subjectName"></el-table-column>
      <el-table-column
        label="更新时间"
        width="150">
        <template slot-scope="{ row }">
          {{ row.updatedTime | dateformat() }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="90">
        <template slot-scope="{ row }">
          <el-button
            style="padding: 0;"
            type="text"
            @click="updateitem(row)">编辑</el-button>
          <el-button
            style="padding: 0;"
            type="text"
            @click="deleteitem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"></el-pagination>
    <div slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'SubjectModal',
  props: { callback: Function, default() {} },
  data() {
    return {
      visible: false,
      loading: false,
      list: [],
      config: { pageNum: 1, pageSize: 10, subjectName: '' },
      total: 0
    }
  },
  methods: {
    updateitem(row) {
      const title = row.id ? '修改' : '新增'
      this.$prompt('请输入考试科目名称', title + '考试科目', {
        confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /^[\u4e00-\u9fa5|a-z|A-Z|\s|\-|0-9]{1,50}$/, inputErrorMessage: '请输入考试科目名称',
        inputValue: row.subjectName || undefined, closeOnClickModal: false,
        beforeClose: (action, instance, done) => {
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            this.loading = true
            const subjectName = instance.inputValue
            const api = row.id ? 'updateexamsubject' : 'addexamsubject'
            this.$$examApi[api]({ subjectName, id: row.id })
              .then(res => {
                this.loading = false
                const { result, message } = res.data
                if ([0].includes(result)) {
                  this.$message.success(title + '成功')
                  this.fetchList()
                  done()
                } else {
                  this.$message.error(message)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
          }
        }
      })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该考试科目?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deleteexamsubject({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleClosed() {
      this.config.pageNum = 1
      this.config.subjectName = ''
      this.list = []
      this.total = 0
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$$examApi.getexamsubjects(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch() {
      this.visible = true
      this.fetchList()
    }
  }
}
</script>
